import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

type CustomInputProps = {
  placeholder?: string;
  value?: string;
  error?: boolean;
  onClick?: () => void;
};

const Input = styled("input")<{ error?: boolean }>(({ theme, error }) =>
  css({
    border: theme.borders.transparent,
    "&:hover": {
      border: theme.borders.primary,
      cursor: "pointer",
    },
    ...(error && {
      border: `${theme.borders.error} !important`,
    }),
  }),
);

export const CustomInput = React.forwardRef(
  (
    { error, value, placeholder, onClick }: CustomInputProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    return (
      <Input
        ref={ref}
        readOnly
        inputMode="none" // スマホのキーボード非表示
        placeholder={placeholder}
        error={error}
        value={value}
        onClick={onClick}
      />
    );
  },
);

CustomInput.displayName = "CustomInput";
